export default function Tour() {
  return (
    <section id="tour" className="py-0 bg-white">
      <div className="grid lg:grid-cols-12">
        {/* Left Side - Image with Overlay - REMOVED */}
      </div>
    </section>
  );
}
